// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"c3-z","displaySixCardTiles":"d3-z"};